import PropTypes from "prop-types";
import { Box, InputAdornment, Stack, TextField } from "@mui/material";
import { Globe } from "lucide-react";

import { TITLE_MAX_LENGTH, extractHost, fieldSx } from "../seoSetupUtils";
import { FieldLabel, ServerErrors, SetupCard } from "../components";

/** `lockUrl`: editing an existing project, whose domain cannot change. */
export function GeneralInfoStep({ general, onChange, errors, showErrors, serverErrors, lockUrl = false }) {
  const host = extractHost(general.url);
  const urlError = showErrors && errors.url;
  const titleError = showErrors && errors.title;

  return (
    <Stack spacing={2}>
      <ServerErrors messages={serverErrors} />

      <SetupCard
        title="Configurar sitio web"
        description="Seguiremos las posiciones del sitio en los principales buscadores. Indica su dominio y cómo se llamará el proyecto."
      >
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, columnGap: 2, rowGap: 1.5 }}>
          <Box>
            <FieldLabel htmlFor="seo-setup-url">URL del sitio web</FieldLabel>
            <TextField
              id="seo-setup-url"
              fullWidth
              size="small"
              value={general.url}
              onChange={(event) => onChange({ url: event.target.value })}
              disabled={lockUrl}
              placeholder="miempresa.com"
              error={Boolean(urlError)}
              helperText={
                urlError ||
                (lockUrl
                  ? "El dominio no se puede cambiar. Para seguir otro dominio hay que crear un proyecto nuevo."
                  : host
                    ? `Se seguirá ${host} con todos sus subdominios y páginas.`
                    : " ")
              }
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <Globe size={16} />
                    </InputAdornment>
                  ),
                },
                htmlInput: { inputMode: "url", autoComplete: "url" },
              }}
              sx={fieldSx}
            />
          </Box>

          <Box>
            <FieldLabel htmlFor="seo-setup-title">Nombre del proyecto</FieldLabel>
            <TextField
              id="seo-setup-title"
              fullWidth
              size="small"
              value={general.title}
              onChange={(event) => onChange({ title: event.target.value.slice(0, TITLE_MAX_LENGTH) })}
              placeholder="Nombre del proyecto"
              error={Boolean(titleError)}
              helperText={titleError || `${general.title.length}/${TITLE_MAX_LENGTH}`}
              sx={fieldSx}
            />
          </Box>
        </Box>
      </SetupCard>
    </Stack>
  );
}

GeneralInfoStep.propTypes = {
  general: PropTypes.shape({ url: PropTypes.string, title: PropTypes.string }).isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  showErrors: PropTypes.bool,
  serverErrors: PropTypes.arrayOf(PropTypes.string),
  lockUrl: PropTypes.bool,
};
